var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTouch = function SvgTouch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 27,
    viewBox: "0 0 45 27",
    width: 45,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.62126 12.4697-5.53038-1.8435 1.84346-5.53034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.4979 6.16507c4.0933.70286 7.9039 2.55064 10.9907 5.32943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3081 10.6115-5.53033-1.84345 1.84346-5.53038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.77594 8.76801c2.32944-1.18606 4.805-2.06 7.36276-2.59928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.5236 3.20265c0-.48891.1942-.95781.54-1.30352.3457-.34572.8146-.53994 1.3035-.53994s.9578.19422 1.3035.53994c.3457.34571.5399.81461.5399 1.30352v8.76385l7.2264 2.155c.5807.1679 1.075.5519 1.3812 1.0731s.401 1.1399.265 1.7289c-.2396 1.0379-1.3734 7.3739-1.5651 8.4357h-11.282l-5.6409-8.4615c-2.2398-3.4233 3.3846-4.6086 5.9304 1.0877z"
  }))));
};
export default SvgTouch;